import { useState } from "react";
import { faqList } from "@/mocks/creatorDirectory";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="faq" className="w-full bg-background-50 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-3xl">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-800">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            关于西瓜视频网红与创作者
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
            浏览时最容易遇到的几个疑问，这里一次说清楚。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqList.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                >
                  <span className="flex items-start gap-3">
                    <i className="ri-question-fill mt-0.5 shrink-0 text-primary-500"></i>
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                  </span>
                  <i
                    className={`shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line rotate-180" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-11 text-xs leading-relaxed text-foreground-600 md:px-6 md:pb-6 md:pl-12 md:text-sm">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}